import React, { useEffect, useState } from 'react';
import Prism from 'prismjs';
import 'prismjs/themes/prism-okaidia.css';
import './PageContent.css'; // Custom CSS for copy button
import { FaDumpster, FaEllipsisV, FaPen, FaTrash } from "react-icons/fa";

import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { Button, Col, Container, Dropdown, Row, Spinner } from 'react-bootstrap';
import DeleteModel from '../../../Utilities/DeleteModal';
import { useSpinner } from '../../../Utilities/SpinnerContext';
import { useBreadcrumbs } from '../../../Utilities/Breadscrumb/BreadcrumbContext';
import moment from 'moment/moment';
import { useUpdateLastReads } from '../../../hooks/useGetLastReads';
import { usePageData } from '../../../hooks/usePageData';

const beURL = localStorage.getItem('BeURL');
const BE_Domain = localStorage.getItem('BE_Domain');



export default function PageContent() {
    const [pageData, setPageContent] = useState([{}]); // Initialize as an object
    const { page_id } = useParams();
    const navigate = useNavigate();
    const [modalShow, setModalShow] = React.useState(false);
    const [deleteData, setDeleteData] = useState({});
    const { showSpinner, hideSpinner } = useSpinner();
    const location = useLocation();
    const { addBreadcrumb } = useBreadcrumbs();

    const{isLoading, data, isSuccess}= usePageData(true,page_id);
    const { mutate: updateLastRead } = useUpdateLastReads();

    // Fetch page content
    useEffect(() => {
        if (isSuccess) {
            const contents = data?.content?.content.content;
    
            if (typeof contents === "string") {
                // Replace the base URL with the dynamic `BE_Domain` only if `contents` is a string
                const moded_content_of_url = contents.replace(/https?:\/\/[^\/]+\/api\/image\//g, `${BE_Domain}/api/image/`);
                
                // Update the content in `data` before setting it in `setPageContent`
                const updatedData = { ...data, content: { ...data.content, content: moded_content_of_url } };
                console.log(updatedData);
                setPageContent(updatedData);
            } else {
                console.error("Expected content to be a string, but got:", typeof contents);
            }
    
            hideSpinner();
        } else if (isLoading) {
            showSpinner();
        }
    }, [isSuccess, data, BE_Domain, isLoading, hideSpinner, showSpinner, setPageContent]);
    



    useEffect(() => {
        if (pageData?.content) {
            updateLastRead(page_id);

            // Add breadcrumb for page content
            addBreadcrumb(pageData?.content.title, location.pathname);
            Prism.highlightAll();

            // Find all <pre><code> blocks and add copy buttons dynamically
            const codeBlocks = document.querySelectorAll('pre code');
            codeBlocks.forEach((block) => {
                const pre = block.parentNode;

                // Check if copy button already exists, skip if so
                if (!pre.querySelector('.copy-button')) {
                    // Create the copy button element
                    const copyButton = document.createElement('button');
                    copyButton.className = 'copy-button';
                    copyButton.innerText = 'Copy';

                    // Add the click event to copy the code
                    copyButton.addEventListener('click', () => {
                        const code = block.textContent;
                        navigator.clipboard.writeText(code).then(() => {
                            copyButton.innerText = 'Copied!';
                            setTimeout(() => {
                                copyButton.innerText = 'Copy';
                            }, 2000); // Reset the button text after 2 seconds
                        });
                    });
                    pre.appendChild(copyButton);
                    pre.style.position = 'relative'; // Ensure position for the copy button
                }
            });
        }
    }, [pageData, addBreadcrumb]); // Re-run when pageData changes

    function handleEdit(pageData) {
        navigate(`/edit/${pageData?.content.id}/${pageData?.content.slug}`, { state: { pageData } });
    }

    function handleDelete(id, name) {
        const deletedata = { 'id': id, 'name': name }
        setModalShow(true);
        setDeleteData(deletedata);
    }


    return (
        <>

            <div className='custom-header-page-content d-flex'>
                <div>
                    <h3 className='mb-3 px-2'>{pageData?.content?.title ? pageData?.content.title : ''}</h3>
                    <div className="d-flex align-items-baseline">
                        <span className='px-2 info_tags'>Tags :</span>
                        <h6 className='px-2'>{pageData.content?.tags ? pageData.content?.tags.map((tag) => (
                            <span className='pointer'><a key={tag.id} onClick={() => navigate(`/tag/pages/${tag.id}`)} class="link-secondary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover">{tag.name} | </a></span>
                        )) : ''} </h6>
                    </div>

                    {pageData.content?.created_at ? (
                        <div className="d-flex align-items-baseline">
                            <span className='px-2 info_tags'>Created Date :</span>
                            <span className='cus-font'> {moment(pageData.content.created_at).format('MMMM Do YYYY, h:mm:ss a')}</span>
                        </div>
                    ) : (
                        <div className="d-flex align-items-baseline">
                            <span className='px-2'>Date :</span>
                            <span> N/A </span>
                        </div>
                    )}



                </div>
                <div>
                    <Dropdown align="end">
                        <Dropdown.Toggle variant="link" className="p-0">
                            <FaEllipsisV />
                        </Dropdown.Toggle>

                        <Dropdown.Menu className='text-sm'>
                            <Dropdown.Item onClick={() => handleEdit(pageData)}>
                                <FaPen /> <span className='small-text'>Edit Page</span>
                            </Dropdown.Item>
                            <Dropdown.Item className='text-danger' onClick={() => handleDelete(pageData?.content.id, pageData?.content.title)}>
                                <FaTrash /><span className='small-text'> Delete Page</span>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

            </div>
            <Container fluid>
                <div
                    className="content"
                    dangerouslySetInnerHTML={{ __html: pageData?.content?.content }} // Dynamically render CKEditor content
                />
            </Container>


            <DeleteModel
                show={modalShow}
                onHide={() => setModalShow(false)}
                deleteData={deleteData}
                deleteBeUrl={`/api/delete/page/${deleteData.id}`}
                AfterDeleteNavigate={-1} //i set to back 1 page
                ToastrMessage={"Page deleted successfully!"}
                ModelHeader={"Are you sure you want to delete this Page? This action cannot be undone."}
                SubHeader={" Below Page Will be Deleted"}
            />
        </>

    );

}
